module.exports = __webpack_public_path__ + "static/media/card1.b4ecef5f.jpg";